import { SDKConfig, configureUserAgent } from "@blacknut/javascript-sdk/dist";
import { i18n } from "i18next";

class ConfigHolder {
  public i18n?: i18n;
  public config: SDKConfig = {
    userAgent: configureUserAgent(),
  };
}
const configHolder = new ConfigHolder();
export default configHolder;
